import { determineEngine, Engine } from 'shared/engine-dynamic';
import * as CordovaAutoUpdate from './cordova-auto-update';
import * as BrowserAutoUpdate from './browser-auto-update';

/**
 * Returns a promise that resolves after the auto updater has
 * done its internal checks and, if aplicable, updated the
 * applciation content.
 *
 * @return {Promise<void>}
 */
export function install() {
    const engine = determineEngine();
    if (engine === Engine.CORDOVA) {
        return CordovaAutoUpdate.install();
    } else {
        return BrowserAutoUpdate.install();
    }
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/index.js